import React from "react";

import { useCurrentWorkspace } from "@accurx/auth";
import { Ds } from "@accurx/design";
import { AutoFocusHeading } from "@accurx/navigation";
import { i } from "images";

import { StyledContent, StyledPageWrapper } from "../MapWorkspacePage.styles";
import { SUPPORT_ARTICLE } from "../util/constants";

export const MapWorkspaceInitial = ({
    onButtonClick,
}: {
    onButtonClick: () => void;
}) => {
    const { organisationName } = useCurrentWorkspace();

    return (
        <StyledPageWrapper
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
        >
            <StyledContent gap="3" flexDirection="column" alignItems="center">
                <img
                    src={i("illustrations/clinical_building.svg")}
                    alt=""
                    width="80"
                    height="80"
                />

                <AutoFocusHeading size="xlarge" as="h1">
                    Select an organisation to continue
                </AutoFocusHeading>

                <Ds.Text>
                    {organisationName} – where you and your colleagues currently
                    work together in Accurx – needs to be linked to an
                    organisation.
                </Ds.Text>

                <Ds.Link href={SUPPORT_ARTICLE} color="night" target="_blank">
                    Why do I need to link my workspace?
                </Ds.Link>

                <Ds.Button onClick={onButtonClick}>
                    Select organisation
                </Ds.Button>
            </StyledContent>
        </StyledPageWrapper>
    );
};
